import { Divider, Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { LastUpdated } from './LastUpdated';
import { PrintForm } from './PrintForm';
import { Title } from './Title';

interface ICompassHeader {
  lastUpdateDate?: Date;
  title?: string;
}

export const CompassHeader = ({ lastUpdateDate, title }: ICompassHeader) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column'}
      alignItems='flex-start'
      justifyContent={'space-between'}
      flexWrap={'wrap'}
    >
      <Title title={title} />
      <Stack
        direction='row'
        alignItems='center'
        justifyContent={isDesktop ? 'flex-end' : 'flex-start'}
        gap={'16px'}
        width={'fit-content'}
      >
        <LastUpdated lastUpdateDate={lastUpdateDate} />
        <Divider
          aria-hidden={'true'}
          orientation='vertical'
          flexItem
          sx={{ borderColor: 'primary.shade_100' }}
        />
        <PrintForm />
      </Stack>
    </Stack>
  );
};
